import { createContext, useContext, type ReactNode } from 'react'
import type { DestinationEvent, DestinationRoute } from '../types'

const EventContext = createContext<DestinationEvent | null>(null)

export function EventProvider({
  event,
  children,
}: {
  event: DestinationEvent
  children: ReactNode
}) {
  return <EventContext.Provider value={event}>{children}</EventContext.Provider>
}

export function useEvent(): DestinationEvent {
  const event = useContext(EventContext)
  if (!event) throw new Error('useEvent must be used inside <EventProvider>.')
  return event
}

export function useEventRoute(): DestinationRoute | null {
  return useEvent().route
}
